import tw, { styled } from "twin.macro"
import { useState, useEffect } from "react"
import useOpenAI from "../hooks/useOpenAI"
import { ReactComponent as MicrophoneIcon } from "../assets/microphone.svg"
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition"
import { speak } from "../OpenAIConfig"
import PageBase from "../components/PageBase"

export default function OpenAIVoice() {
  const [prevPrompt, setPreviousPrompt] = useState("")
  const { response, error, loading, generate, resetMemory } = useOpenAI()
  const {
    transcript,
    resetTranscript,
    listening,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition()

  const handleToggleListen = () => {
    if (listening) {
      SpeechRecognition.stopListening()
      if (!transcript) return
      setPreviousPrompt(transcript)
      generate(transcript)
      resetTranscript()
    } else {
      SpeechRecognition.startListening()
    }
  }

  useEffect(() => {
    if (!response) return
    speak(response)
  }, [response])

  if (!browserSupportsSpeechRecognition)
    return (
      <Wrapper>
        <Title>Browser doesn't support this feature</Title>
      </Wrapper>
    )

  const openAI = { response, error, loading, prevPrompt, resetMemory }

  return (
    <PageBase title="Voice Chat" openAI={openAI}>
      <ListenButton turnRed={listening} onClick={handleToggleListen}>
        <Microphone />
        <span>{listening ? "Listening" : "Idle"}</span>
      </ListenButton>
    </PageBase>
  )
}

const Wrapper = tw.div`mt-8 flex flex-col items-center gap-5`
const Title = tw.h1`text-3xl font-bold`
const ListenButton = styled.button(({ turnRed }) => [
  tw`h-10 rounded-lg bg-neutral-700 hover:bg-neutral-600 text-white font-bold flex items-center gap-4 px-4 py-2`,
  turnRed && tw`text-red-500`,
])
const Microphone = tw(MicrophoneIcon)`w-6 h-6`
